import {call, put, takeEvery, takeLatest} from 'redux-saga/effects';
import {
    onPosIntegrationsLoad,
    onPosIntegrationsLoadSuccess,
    onPosIntegrationsLoadFail,
    onPosIntegrationsSave,
    onPosIntegrationsSaveSuccess,
    onPosIntegrationsSaveFail,
    onIikoTransportOrganizationsLoad,
    onIikoTransportOrganizationsLoadSuccess,
    onIikoTransportOrganizationsLoadFail,
    onIikoTransportOrganizationsShowModal,
    onIikoTransportSetOrganization,
    onIikoTransportSetOrganizationSuccess,
    onIikoTransportSetOrganizationFail,
    onIikoTransportUpdateSelectedField,
    onIikoTransportTerminalsShowModal,
    onIikoTransportSetTerminal,
    onIikoTransportSetTerminalSuccess,
    onIikoTransportSetTerminalFail,
    onIikoTransportTerminalsLoad,
    onIikoTransportTerminalsLoadSuccess,
    onIikoTransportTerminalsLoadFail,
    onIikoTransportPaymentsLoad,
    onIikoTransportSetPayment,
    onIikoTransportPaymentsLoadSuccess,
    onIikoTransportPaymentsShowModal,
    onIikoTransportPaymentsLoadFail,
    onIikoTransportSetPaymentSuccess,
    onIikoTransportSetPaymentFail,
    onIikoTransportImportTables,
    onIikoTransportImportTablesSuccess,
    onIikoTransportImportTablesFail,
    onRestaurantLoad,
    onRestaurantLoadSuccess,
    onRestaurantLoadFail,
    onRestaurantSave,
    onRestaurantSaveSuccess,
    onRestaurantSaveFail,
    onRestaurantTimesSave,
    onRestaurantTimesSaveSuccess,
    onRestaurantTimesSaveFail,
    onTablesLoad,
    onTablesLoadSuccess,
    onTablesLoadFail,
    onIikoTransportImportDiscounts,
    onDiscountsLoad,
    onDiscountsLoadFail,
    onDiscountsLoadSuccess,
    onIikoTransportImportDiscountsSuccess,
    onIikoTransportImportDiscountsFail,
    onSelectServiceChargeId,
    onSelectServiceChargeIdSuccess,
    onSelectServiceChargeIdFail,
    onIikoTransportExternalMenuLoad,
    onIikoTransportSetExternalMenu,
    onIikoTransportExternalMenuLoadSuccess,
    onIikoTransportExternalMenuShowModal,
    onIikoTransportExternalMenuLoadFail,
    onIikoTransportSetExternalMenuSuccess, onIikoTransportSetExternalMenuFail
} from "./actions";
import {
    integrationsSave,
    integrationsLoad,
    getIikoTransportOrganizations,
    saveOrganization,
    getIikoTransportTerminals,
    saveTerminal,
    savePayment,
    getIikoTransportPayments,
    importTables,
    getRestaurant,
    restaurantSaveDetails, restaurantSaveTimes,
    loadTables, importDiscounts, loadDiscounts, setServiceChargeId, getIikoTransportExternalMenus, saveExternalMenu
} from "./api";
import { QueryClient } from '@tanstack/react-query';

function* sgRestaurantLoad(action) {
    try {
        const response = yield call(getRestaurant, action.restaurant_id )

        yield put(onRestaurantLoadSuccess(response))
    } catch (e) {
        yield put(onRestaurantLoadFail(e))
    }
}
function* sgRestaurantSave(action) {
    try {
        // let meta = document.getElementsByName("csrf-token")[0];
        const response = yield call(restaurantSaveDetails, action.restaurant_id, action.params )

        yield put(onRestaurantSaveSuccess(response))
    } catch (e) {
        yield put(onRestaurantSaveFail(e))
    }
}
function* sgRestaurantTimesSave(action) {
    try {
        // let meta = document.getElementsByName("csrf-token")[0];
        const response = yield call(restaurantSaveTimes, action.restaurant_id, action.params )

        yield put(onRestaurantTimesSaveSuccess(response))
    } catch (e) {
        yield put(onRestaurantTimesSaveFail(e))
    }
}
function* sgIntegrationSave(action) {
    try {
        const response = yield call(integrationsSave, action.data )

        yield put(onPosIntegrationsSaveSuccess(response))
        yield action.invalidateStore()
    } catch (e) {
        yield put(onPosIntegrationsSaveFail(e))
    }
}

function* sgIntegrationLoad(action) {
    try {
        let params = {
            restaurant_id: action.restaurant_id
        }
        const response = yield call(integrationsLoad, params)

        if (response?.pos_selected?.integration?.name === 'iiko_transport') {

            if (response?.pos_selected?.params?.api_login) {
                yield put(onIikoTransportUpdateSelectedField('api_login',response.pos_selected.params.api_login ))
            }
            if (response?.pos_selected?.params?.organization_id) {
                yield put(onIikoTransportUpdateSelectedField('organization_id',response.pos_selected.params.organization_id ))
            }
            if (response?.pos_selected?.params?.terminal_group_id) {
                yield put(onIikoTransportUpdateSelectedField('terminal_group_id',response.pos_selected.params.terminal_group_id ))
            }
            if (response?.pos_selected?.params?.payment_id) {
                yield put(onIikoTransportUpdateSelectedField('payment_id',response.pos_selected.params.payment_id ))
            }
            if (response?.pos_selected?.params?.server) {
                yield put(onIikoTransportUpdateSelectedField('server',response.pos_selected.params.server ))
            }
        }

        yield put(onPosIntegrationsLoadSuccess(response))
    } catch (e) {
        yield put(onPosIntegrationsLoadFail(e))
    }
}

function* sgIikoTransportOrganizations(action) {
    try {
        let params = {
            restaurant_id: action.restaurant_id,
            api_login: action.api_login
        }
        const response = yield call(getIikoTransportOrganizations, params)

        yield put(onIikoTransportOrganizationsLoadSuccess(response))
        yield put(onIikoTransportOrganizationsShowModal(true))
    } catch (e) {
        yield put(onIikoTransportOrganizationsLoadFail(e))
    }
}
function* sgIikoSetOrganization(action) {
    try {
        const response = yield call(saveOrganization, action.params )

        yield put(onIikoTransportSetOrganizationSuccess(response))
        if (response?.integration_params?.params?.organization_id) {
            yield put(onIikoTransportUpdateSelectedField('organization_id',response.integration_params.params.organization_id ))
        }
    } catch (e) {
        yield put(onIikoTransportSetOrganizationFail(e))
    }
}

/**
 * Terminals
 */
function* sgIikoTerminalsLoad(action) {
    try {
        let params = {
            restaurant_id: action.restaurant_id,
            integration_id: action.integration_id
        }
        const response = yield call(getIikoTransportTerminals, params)

        yield put(onIikoTransportTerminalsLoadSuccess(response))
        yield put(onIikoTransportTerminalsShowModal(true))
    } catch (e) {
        yield put(onIikoTransportTerminalsLoadFail(e))
    }
}
function* sgIikoSetTerminal(action) {
    try {
        const response = yield call(saveTerminal, action.params )

        yield put(onIikoTransportSetTerminalSuccess(response))
        if (response?.integration_params?.params?.terminal_group_id) {
            yield put(onIikoTransportUpdateSelectedField('terminal_group_id',response.integration_params.params.terminal_group_id ))
        }
    } catch (e) {
        yield put(onIikoTransportSetTerminalFail(e))
    }
}
/**
 * Payments
 */
function* sgIikoPaymentsLoad(action) {
    try {
        let params = {
            restaurant_id: action.restaurant_id,
            integration_id: action.integration_id
        }
        const response = yield call(getIikoTransportPayments, params)

        yield put(onIikoTransportPaymentsLoadSuccess(response))
        yield put(onIikoTransportPaymentsShowModal(true))
    } catch (e) {
        yield put(onIikoTransportPaymentsLoadFail(e))
    }
}
function* sgIikoSetPayment(action) {
    try {
        const response = yield call(savePayment, action.params )

        yield put(onIikoTransportSetPaymentSuccess(response))
        if (response?.integration_params?.params?.payment_id) {
            yield put(onIikoTransportUpdateSelectedField('payment_id',response.integration_params.params.payment_id ))
        }
    } catch (e) {
        yield put(onIikoTransportSetPaymentFail(e))
    }
}
/**
 * ExternalMenu
 */
function* sgIikoExternalMenusLoad(action) {
    try {
        let params = {
            restaurant_id: action.restaurant_id,
            integration_id: action.integration_id
        }
        const response = yield call(getIikoTransportExternalMenus, params)

        yield put(onIikoTransportExternalMenuLoadSuccess(response))
        yield put(onIikoTransportExternalMenuShowModal(true))
    } catch (e) {
        yield put(onIikoTransportExternalMenuLoadFail(e))
    }
}
function* sgIikoSetExternalMenu(action) {
    try {
        const response = yield call(saveExternalMenu, action.params )

        yield put(onIikoTransportSetExternalMenuSuccess(response))
        if (response?.integration_params?.params?.external_menu_id) {
            yield put(onIikoTransportUpdateSelectedField('external_menu_id',response.integration_params.params.external_menu_id ))
        }
    } catch (e) {
        yield put(onIikoTransportSetExternalMenuFail(e))
    }
}

/**
 * Tables
 * @param action
 * @returns {Generator<*, void, *>}
 */
function* sgIikoTransportImportTables(action) {
    try {
        let params = {
            restaurant_id: action.restaurant_id,
            integration_id: action.integration_id
        }
        const response = yield call(importTables, params)

        yield put(onIikoTransportImportTablesSuccess(response))
    } catch (e) {
        yield put(onIikoTransportImportTablesFail(e))
    }
}

function* sgIikoTransportTablesLoad(action) {
    try {
        const params = {
            restaurant_id: action.restaurant_id,
            page: action.page,
        }

        const response = yield call(loadTables, params)

        yield put(onTablesLoadSuccess(response))
    } catch (e) {
        yield put(onTablesLoadFail(e))
    }
}

function* sgIikoTransportImportDiscounts(action) {
    try {
        let params = {
            restaurant_id: action.restaurant_id,
            integration_id: action.integration_id
        }
        const response = yield call(importDiscounts, params)

        yield put(onIikoTransportImportDiscountsSuccess(response))
    } catch (e) {
        yield put(onIikoTransportImportDiscountsFail(e))
    }
}

function* sgIikoTransportDiscountsLoad(action) {
    try {
        const params = {
            restaurant_id: action.restaurant_id,
            page: action.page,
        }

        const response = yield call(loadDiscounts, params)

        yield put(onDiscountsLoadSuccess(response))
    } catch (e) {
        yield put(onDiscountsLoadFail(e))
    }
}

function* sgSelectChargeId(action) {
    try {
        const { invalidateStore, ...params } = action

        const response = yield call(setServiceChargeId, {...params})
        yield invalidateStore()
        yield put(onSelectServiceChargeIdSuccess(response))
    } catch (e) {
        yield put(onSelectServiceChargeIdFail(e))
    }
}

function* restaurantSaga() {
    yield takeEvery(onRestaurantLoad().type, sgRestaurantLoad);
    yield takeEvery(onRestaurantSave().type, sgRestaurantSave);
    yield takeEvery(onRestaurantTimesSave().type, sgRestaurantTimesSave);

    yield takeEvery(onPosIntegrationsSave().type, sgIntegrationSave);
    yield takeEvery(onPosIntegrationsLoad().type, sgIntegrationLoad);
    yield takeEvery(onIikoTransportOrganizationsLoad().type, sgIikoTransportOrganizations);
    yield takeEvery(onIikoTransportSetOrganization().type, sgIikoSetOrganization);

    yield takeEvery(onIikoTransportTerminalsLoad().type, sgIikoTerminalsLoad);
    yield takeEvery(onIikoTransportSetTerminal().type, sgIikoSetTerminal);

    yield takeEvery(onIikoTransportPaymentsLoad().type, sgIikoPaymentsLoad);
    yield takeEvery(onIikoTransportSetPayment().type, sgIikoSetPayment);

    yield takeEvery(onIikoTransportImportTables().type, sgIikoTransportImportTables);
    yield takeLatest(onTablesLoad().type, sgIikoTransportTablesLoad);

    yield takeEvery(onIikoTransportImportDiscounts().type, sgIikoTransportImportDiscounts);
    yield takeLatest(onDiscountsLoad().type, sgIikoTransportDiscountsLoad);

    yield takeLatest(onSelectServiceChargeId().type, sgSelectChargeId);

    yield takeEvery(onIikoTransportImportDiscounts().type, sgIikoTransportImportDiscounts);

    yield takeEvery(onIikoTransportExternalMenuLoad().type, sgIikoExternalMenusLoad);
    yield takeEvery(onIikoTransportSetExternalMenu().type, sgIikoSetExternalMenu);
}

export default restaurantSaga;
